import React from 'react'
import style from "./index.less"
import Footer from "components/Footer"
import Contact from "components/Contact"

class pageFive extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }

    }

    toPhone() {
        // this.props.history.push("/");
    }

    toVIP() {
        // this.props.history.push("/");
    }







    render() {
        return (
            // <div className={style.pageFive_container}>
            //     <div className={style.pageFive_top}>
            //         <div className={style.pageFive_left}>
            //             <div className={style.fontOne}>
            //                 <div className={style.sthz}>
            //                     生态合作
            //                 </div>
            //                 <div className={style.picOne}>
            //                 </div>
            //             </div>
            //             <div className={style.fontTwo}>
            //                 {/* <p onClick={this.toPhone}>项目合作,留下您的联系方式<ArrowRightOutlined /></p> */}
            //                 <p>共建生态，合作共赢</p>
            //             </div>
            //             <div className={style.fontThree}>
            //                 <img className={style.point} src={require('assets/images/home/背景点点-.png')} alt="" />
            //             </div>
            //             {/* <div className={style.fontFour}>
            //                 <p onClick={this.toVIP}>申请成为VIP用户<ArrowRightOutlined /></p>
            //             </div> */}

            //         </div>
            //         <div className={style.pageFive_right}>
            //             <img className={style.pageFive_right.img} src={require('assets/images/home/logo.png')} alt="" />
            //         </div>
            //     </div>
            //     {/* <div className={style.pageFive_divider}>
            //         <Divider />
            //     </div> */}
            //     <div className={style.pageFive_footer}>
            //         <Footer />
            //     </div>
            // </div>
            <div className={style.pageFive_container}>
                <Contact />
            </div>
        )
    }

}

export default pageFive